module.exports = __webpack_public_path__ + "static/img/ufo.5549e994.png";